// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EMi9g","left":"styles_left__3S_a2"};